<!--
 * @FilePath: ArticleDetail.vue
 * @Author: 孙新宇
 * @Date: 2022-12-27 10:21:55
 * @LastEditTime: 2023-03-25 16:53:34
 * @Descripttion: 
-->
<!--  -->
<template>
  <div>
    <van-nav-bar class="top" title="" left-text="返回" fixed="true" placeholder="true" left-arrow
      @click-left="onClickLeft" />
    <!-- <div>类别:{{ $route.params.category }}</div> -->
    <!-- <div>id:{{ $route.params.id }}</div> -->
    <h2 style="
          text-align: center;
          font-size: 24px;
          word-wrap: break-word;
          word-break: break-all;
        ">
      {{ $route.params.id.title }}
    </h2>
    <hr />
    <br />
    <div v-html="blog" class="content markdown-body"></div>
    <br />
    <div style="text-align: center; color: #6a737d">—— The End ——</div>
    <div style="height: 20px"></div>
  </div>
</template>

<script>
import Vue from "vue";
import { NavBar } from "vant";
import { Toast } from "vant";
import { marked } from "marked";
import { ImagePreview } from "vant";
import { suntae_axios } from "../http";

Vue.use(NavBar);
Vue.use(Toast);

export default {
  data() {
    return {
      // 用于渲染文章
      blog: "",
      imgs: "", // 用于存放图片DOM
    };
  },
  beforeRouteLeave(to, from, next) {
    to.meta.keepAlive = true;
    next(0);
  },
  methods: {
    onClickLeft() {
      // Toast("返回");
      this.$router.go(-1);
    },
    // 给图片添加预览功能
    previewImg() {
      this.imgs = document.querySelectorAll(".content img");

      let temp = [];

      for (let i = 0; i < this.imgs.length; i++) {
        temp.push("" + this.imgs[i].src);

        this.imgs[i].addEventListener("click", function () {
          ImagePreview([temp[i]]);
        });
      }
      console.log("@", this.imgs);
    },
    toTop() {
      let top = document.getElementsByClassName("top")[0];
      top.scrollIntoView();
    },
  },
  beforeMount() {
    marked.setOptions({
      renderer: new marked.Renderer(),
      gfm: true,
      tables: true,
      breaks: true,
      pedantic: false,
      sanitize: false,
      smartLists: true,
      smartypants: false,
    }); //基本设置

    // 请求内容
    suntae_axios("/api/help_manual/common_problem/get_one_article", {
      id: this.$route.params.id.id,
    }).then((res) => {
      this.blog = marked(res.result.content);

      // console.log(this.blog);
    });
  },
  mounted() {
    this.toTop();

    this.previewImg();
  },
  updated() {
    // 跳转到头部
    this.toTop();

    this.previewImg();
  },
};
</script>
<style scoped>
@import "../assets/css/markdown.css";

.content {
  width: 96%;
  margin-left: 2%;
}
</style>